import { render, staticRenderFns } from "./BtKpi.vue?vue&type=template&id=be3f07ea&"
import script from "./BtKpi.vue?vue&type=script&lang=js&"
export * from "./BtKpi.vue?vue&type=script&lang=js&"
import style0 from "./BtKpi.vue?vue&type=style&index=0&id=be3f07ea&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports